/**
 * 接口异常定义自己的错误类型
 * @param {*} message 错误信息
 * @param {*} code 错误编码
 *
 */
export class APIError extends Error {
  code: string | number | undefined;

  constructor(message: string, code?: string | number) {
    super(message);
    this.name = 'APIError';
    this.code = code;
    this.message = message;
  }
}
